import { render } from "./Spark-Sidebar-Link.vue?vue&type=template&id=82fc4060&ts=true"
import script from "./Spark-Sidebar-Link.vue?vue&type=script&lang=ts"
export * from "./Spark-Sidebar-Link.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__